import { createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { SupportOrgLogModels } from '@models/support-org-log.model';
import { SupportOrganizationLogActions } from './support-organization-log.actions-types';
import { beforeGetSupportOrgLogs } from '@states/support-organization-log/support-organization-log.actions';

export declare interface SupportOrganizationLogState extends EntityState<SupportOrgLogModels.Document> {
  isLoading: boolean;
  // initialLoaded: boolean;// show loader until first loading happening
  // notEmpty: boolean; //show no Data if result empty
  // listLoading: boolean; //show loaded each time when query params changed,
  /**
   * Paging required
   */
  latestTs: number;
  isLastPage: boolean;
}

export const supportOrganizationLogAdapter = createEntityAdapter<SupportOrgLogModels.Document>({
  selectId: (model) => model._id,
});

const initialState: SupportOrganizationLogState = supportOrganizationLogAdapter.getInitialState({
  isLoading: true,

  latestTs: null,
  isLastPage: false,
});

export const supportOrganizationLogStateReducer = createReducer(
  initialState,
  on(SupportOrganizationLogActions.resetToInitialState, (state) => {
    return {
      ...initialState,
    };
  }),
  on(SupportOrganizationLogActions.getSupportOrgLogsSuccess, (state, { documents }) => {
    const totalLength = documents.length;

    if (!totalLength) {
      return {
        ...state,
        isLoading: false,
        isLastPage: true,
      };
    }

    return supportOrganizationLogAdapter.addMany(documents, {
      ...state,
      isLoading: false,
      isLastPage: documents.length < SupportOrgLogModels.PAGE_LIMIT,
      latestTs: documents[totalLength - 1].createdAt,
    });
  }),
  on(SupportOrganizationLogActions.beforeGetSupportOrgLogs, (state) => {
    return supportOrganizationLogAdapter.removeAll({
      ...state,
      isLoading: true,
      isLastPage: initialState.isLastPage,
      latestTs: initialState.latestTs,
    });
  }),
  on(SupportOrganizationLogActions.setSupportOrgLogsLoader, (state, { loading }) => {
    return {
      ...state,
      isLoading: loading,
    };
  }),
  on(SupportOrganizationLogActions.getSupportOrgLogsFail, (state) => {
    return {
      ...state,
      isLoading: false,
    };
  }),
);
